import { useState, useEffect } from "react";
import {
  Dialog,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Close, Save } from "@mui/icons-material";
import theme from "../../theme/theme";
import ZoneSelect from "../common/ZoneSelect";
import CitySelect from "../common/CitySelect";

export const CreateProjectFromLeadDialog = ({
  open,
  onClose,
  saving,
  onSave,
  errors = {},
}) => {
  const [formData, setFormData] = useState({
    project_id: "",
    project_name: "",
    zone_id: "",
    city_id: "",
  });

  useEffect(() => {
    if (open) {
      setFormData({ project_id: "", project_name: "", zone_id: "", city_id: "" });
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "zone_id") {
      setFormData({ ...formData, zone_id: value, city_id: "" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const submit = () => {
    onSave(formData);
  };

  return (
    <Dialog
      open={open}
      onClose={!saving ? onClose : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: theme.dialog.borderRadius,
          minWidth: theme.dialog.minWidth,
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            fontWeight={"bold"}
            color={theme.palette.primary.main}
          >
            Create Project from Lead
          </Typography>
        </Box>
        <Box>
          <IconButton onClick={!saving ? onClose : undefined} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ p: 4 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Lift details, capacity, and other specifications will be automatically
          populated from the lead data.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField
            fullWidth
            label="Project ID"
            name="project_id"
            value={formData.project_id}
            onChange={handleChange}
            disabled={saving}
            error={!!errors.project_id}
            helperText={errors.project_id?.[0]}
          />
          <TextField
            fullWidth
            label="Project Name"
            name="project_name"
            value={formData.project_name}
            onChange={handleChange}
            disabled={saving}
            error={!!errors.project_name}
            helperText={errors.project_name?.[0]}
          />
        </Box>
        <ZoneSelect
          fullWidth
          value={formData.zone_id}
          onChange={(id) =>
            setFormData((f) => ({ ...f, zone_id: id, city_id: "" }))
          }
          disabled={saving}
          error={!!errors.zone_id}
          helperText={errors.zone_id?.[0]}
          sx={{ mb: 2 }}
        />
        <CitySelect
          fullWidth
          zoneId={formData.zone_id}
          value={formData.city_id}
          onChange={(id) => setFormData((f) => ({ ...f, city_id: id }))}
          disabled={saving}
          error={!!errors.city_id}
          helperText={
            errors.city_id?.[0] ||
            (!formData.zone_id ? "Select a zone first" : "")
          }
          sx={{ mb: 2 }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          disabled={saving}
          sx={{
            backgroundColor: theme.button.backgroundColor,
            color: "#000",
            borderRadius: theme.button.borderRadius,
          }}
        >
          Close
        </Button>
        <Button
          variant="contained"
          onClick={submit}
          disabled={saving}
          sx={{
            backgroundColor: theme.button.editBackgroundColor,
            borderRadius: theme.button.borderRadius,
          }}
          startIcon={<Save />}
        >
          {saving ? "Creating..." : "Create Project"}
        </Button>
      </Box>
    </Dialog>
  );
};
